import { render, staticRenderFns } from "./Capsule.vue?vue&type=template&id=18b0ad73&scoped=true"
import script from "./Capsule.vue?vue&type=script&lang=js"
export * from "./Capsule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0ad73",
  null
  
)

export default component.exports